import {
  DEFAULT_INITIAL_PAGE,
  DEFAULT_INITIAL_PAGE_SIZE,
} from 'constants/pagination'
import { SP_PAGE, SP_PAGE_SIZE } from 'constants/searchParams'
import { useSearchParams } from 'react-router-dom'

export const usePagination = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const page = Number(searchParams.get(SP_PAGE)) || DEFAULT_INITIAL_PAGE
  const pageSize = searchParams.get(SP_PAGE_SIZE) || DEFAULT_INITIAL_PAGE_SIZE

  const handleResetPagination = () => {
    setSearchParams({
      [SP_PAGE]: DEFAULT_INITIAL_PAGE.toString(),
    })
  }

  const handlePageSizeChange = (newPageSize: string) => {
    setSearchParams({
      [SP_PAGE_SIZE]: newPageSize,
    })
  }

  const handlePageChange = (newPage: number) => {
    setSearchParams({
      [SP_PAGE]: newPage.toString(),
    })
  }

  return {
    page,
    pageSize,
    handleResetPagination,
    handlePageSizeChange,
    handlePageChange,
  }
}
